import React from 'react';
import { CheckCircle, Calendar } from 'lucide-react';

interface DrawExecutedStateProps {
  theme?: {
    background_color: string;
    text_color: string;
  };
}

const DrawExecutedState: React.FC<DrawExecutedStateProps> = ({ theme }) => {
  const backgroundColor = theme?.background_color || '#2563eb';
  
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ background: `linear-gradient(to bottom right, ${backgroundColor}, ${backgroundColor}dd)` }}
    >
      <div className="text-center text-white max-w-md mx-auto p-8">
        <div className="mb-6">
          <div className="mx-auto h-20 w-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="h-12 w-12" />
          </div>
          <h1 className="text-3xl font-bold mb-3">Sorteio Finalizado</h1>
          <p className="text-lg opacity-90 mb-6">
            Este sorteio já foi realizado e não está mais aceitando novos participantes.
          </p>
        </div>

        <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 border border-white border-opacity-20">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Calendar className="h-5 w-5" />
            <p className="font-medium">Sorteio Encerrado</p>
          </div>
          <p className="text-sm opacity-80">
            O ganhador já foi selecionado e notificado. Obrigado pelo seu interesse!
          </p>
        </div>

        <div className="mt-8 text-sm opacity-75">
          <p>Fique atento às nossas próximas promoções</p>
        </div>
      </div>
    </div>
  );
};

export default DrawExecutedState;
